import { _IdBase } from "./_id.base"
import { EProcessStatus } from "./enums"
import { IUserDto } from "./i-user.dto"

export enum ESigningOrderType {
  paralel = 1,
  serial = 2,
  custom = 3
}

export enum EProcessSharing {
  creatorSigners = 'CREATOR_SIGNERS',
  creatorSignersTeams = 'CREATOR_SIGNERS_TEAMS'
}
export interface IProcessDto extends _IdBase {


  description: string
  validTill?: Date
  created: Date,
  status: EProcessStatus
  statusChanged?: Date
  canDownloadDocuments?: boolean
  creator?: IUserDto
  note?: string,
  signingOrderType: ESigningOrderType,
  processSharingType: EProcessSharing,
  statusChangedReason?: string
  userIsTeamMember?: boolean

}
